import { useCallback } from 'react';

import { hasAllPermissions } from './permission-checks';

import { type Permission, useGetPermissions } from '../entities/permissions';

export const useHasPermissions = () => {
  const permissionsQuery = useGetPermissions();
  const granted = permissionsQuery.data;

  const checkPermissions = useCallback(
    (required: Permission[]) => {
      if (!granted) {
        return false;
      }

      return hasAllPermissions(granted, required);
    },
    [granted]
  );

  return { checkPermissions, isLoading: permissionsQuery.isLoading };
};
